import { createAsyncThunk } from '@reduxjs/toolkit';
import { StoreState } from '../../../../store/store.interface';
import { MyDigitalProductAggregatedItem } from '../interface/my-digital-products-aggregated.interface';
import {
  isLoadingMyDigitalProductsAggregated,
  isSucceededMyDigitalProductsAggregated,
} from '../store/my-digital-products-aggregated.selectors';
import { getMyDigitalProductsAggregatedApiCall } from '../api/my-digital-products-aggregated.apis';

/**
 * WECOOL-52277 — fetches the aggregated My Digital Products + Inclusive Access
 * data from the live endpoint (GET /accounts/api/v1/optinout).
 * MH_TOKEN is read INSIDE the api call (never at module scope).
 *
 * Caller must dispatch after `waitForUser()` resolves so the cookie is set.
 */
async function resolve(): Promise<MyDigitalProductAggregatedItem[]> {
  return await getMyDigitalProductsAggregatedApiCall();
}

/** Pass `{ force: true }` to bypass the loading/succeeded dedup guard (used after a POST). */
export interface FetchMyDigitalProductsAggregatedArg {
  force?: boolean;
}

export const fetchMyDigitalProductsAggregated = createAsyncThunk<
  MyDigitalProductAggregatedItem[],
  FetchMyDigitalProductsAggregatedArg | void
>(
  'myDigitalProductsAggregated/fetch',
  async (_arg, thunkAPI) => {
    try {
      return await resolve();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: (arg, { getState }) => {
      if (arg && typeof arg === 'object' && arg.force) {
        return true;
      }
      const state = getState() as StoreState;
      if (isLoadingMyDigitalProductsAggregated(state) || isSucceededMyDigitalProductsAggregated(state)) {
        return false;
      }
      return true;
    },
  }
);
